(() => {
  const body = document.body;

  const toggleLayer = (selector, open, bodyClass) => {
    const layer = document.querySelector(selector);
    if (!layer) return;
    layer.classList.toggle('is-open', open);
    layer.setAttribute('aria-hidden', open ? 'false' : 'true');
    body.classList.toggle(bodyClass, open);
    if (open) {
      const focusTarget = layer.querySelector('input, button, a');
      window.setTimeout(() => focusTarget?.focus(), 80);
    }
  };

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-action]');
    if (!trigger) return;
    const action = trigger.dataset.action;

    if (action === 'open-menu') toggleLayer('[data-mobile-drawer]', true, 'menu-open');
    if (action === 'close-menu') toggleLayer('[data-mobile-drawer]', false, 'menu-open');
    if (action === 'open-search') toggleLayer('[data-search-drawer]', true, 'search-open');
    if (action === 'close-search') toggleLayer('[data-search-drawer]', false, 'search-open');
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    toggleLayer('[data-mobile-drawer]', false, 'menu-open');
    toggleLayer('[data-search-drawer]', false, 'search-open');
  });

  document.querySelectorAll('[data-sort-select]').forEach((select) => {
    select.addEventListener('change', () => {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', select.value);
      window.location.href = url.toString();
    });
  });

  document.querySelectorAll('[data-variant-select]').forEach((select) => {
    const form = select.closest('form');
    const price = form?.closest('[data-product-info]')?.querySelector('[data-product-price]');
    const button = form?.querySelector('[data-add-to-cart]');

    select.addEventListener('change', () => {
      const option = select.options[select.selectedIndex];
      if (price && option.dataset.price) price.textContent = option.dataset.price;
      if (button) {
        const available = option.dataset.available === 'true';
        button.disabled = !available;
        button.textContent = available ? button.dataset.availableText : button.dataset.soldText;
      }
    });
  });

  document.querySelectorAll('[data-product-gallery]').forEach((gallery) => {
    const slides = [...gallery.querySelectorAll('[data-gallery-slide]')];
    const thumbs = [...gallery.querySelectorAll('[data-gallery-thumb]')];

    thumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => {
        const selected = thumb.dataset.galleryThumb;
        slides.forEach((slide) => {
          const active = slide.dataset.gallerySlide === selected;
          slide.hidden = !active;
          slide.classList.toggle('is-active', active);
        });
        thumbs.forEach((item) => {
          const active = item === thumb;
          item.classList.toggle('is-active', active);
          item.setAttribute('aria-pressed', active ? 'true' : 'false');
        });
      });
    });
  });
})();
